<template>
    <div class="page">
        <div class="userInfo">
            <img src="@/assets/wen/bj.png" class="bjimg" />
            <div class="logo">
                <img src="@/assets/wen/logo3.png" />
            </div>
            <div class="title">账号信息</div>
            <div class="user-item">
                <div class="label">昵称：</div>
                <div class="value" style="color: rgb(67, 125, 224);" v-if="myNikeName && myNikeName.length > 0">{{ myNikeName
                }}</div>
                <div class="value" style="color: rgb(67, 125, 224);" v-else @click="login">请登录后查询</div>
            </div>
            <div class="user-item">
                <div class="label">手机号：</div>
                <div class="value">{{ myLoginPhone }}</div>
            </div>
        </div>
        <div class="order-container">
            <div class="order" @click="toSelectOrder">
                <div class="main">
                    <div class="top">
                        <img src="@/assets/wen/order.png" alt="">
                        <div class="order-top-title">我的订单</div>
                        <div class="order-top-allOrder">
                            全部订单
                            <van-icon name="arrow" />
                        </div>
                    </div>
                    <div class="orders">
                        <div class="order-item">
                            <img src="@/assets/wen/dfh.png" alt="" style="width: 27px;">
                            <div class="order-1">
                                <div class="order-count1">{{ myData.chuli }}</div>
                                <div class="order-item-text">待发货</div>
                            </div>
                        </div>
                        <div class="order-item">
                            <img src="@/assets/wen/dsh.png" alt="" style="width: 27px;">
                            <div class="order-1">
                                <div class="order-count2">{{ myData.shouhuo }}</div>
                                <div class="order-item-text">待收货</div>
                            </div>
                        </div>
                        <div class="order-item">
                            <img src="@/assets/wen/shjj.png" alt="" style="width: 27px;">
                            <div class="order-1">
                                <div class="order-count3">{{ myData.jujue }}</div>
                                <div class="order-item-text">审核拒绝</div>
                            </div>
                        </div>
                        <div class="order-item">
                            <img src="@/assets/wen/ywc.png" alt="" style="width: 27px;">
                            <div class="order-1">
                                <div class="order-count">{{ myData.wancheng }}</div>
                                <div class="order-item-text">已完成</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="we">
            <div class="userfeedback" @click="toOut()">注销登录</div>
        </div>
        <div class="f-tab">
            <van-tabbar v-model="active" @change="onChange">
                <van-tabbar-item icon="home-o">首页</van-tabbar-item>
                <van-tabbar-item icon="service-o">客服</van-tabbar-item>
                <van-tabbar-item icon="friends-o">我的</van-tabbar-item>
            </van-tabbar>
        </div>
    </div>
</template>
<script>
// 脚本部分保持不变
import { Toast, Dialog } from 'vant';
import { wxRequest } from '@/api/user'
export default {
    data() {
        return {
            myNikeName: localStorage.getItem('myNikeName'),
            myLoginPhone: '**************',

            active: 3,
            show: false,
            iccid: '',

            myData: {
                chuli: '',
                jujue: '',
                shouhuo: '',
                wancheng: ''
            }
        }
    },
    created() {
        var loginPhone = localStorage.getItem('myLoginPhone');
        if (loginPhone) {
            this.toSelectData();
            this.myLoginPhone = loginPhone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
        }
    },
    methods: {
        toSelectData() {
            wxRequest("applyChangeSim/selectCountPhone", { userPhone: localStorage.getItem('myLoginPhone') }, "post").then(res => {
                if (res.data.code == '200') {
                    this.myData = res.data.data;
                }
            })
        },
        toSelectOrder() {
            var loginPhone = localStorage.getItem('myLoginPhone');
            if (loginPhone && loginPhone.length > 5) {
                this.$router.push({ name: 'buyOrderSearchDetails', query: { idCard: loginPhone, takePhone: loginPhone } })
            } else {
                Dialog.confirm({
                    title: "绑定提示",
                    message: "请先登录注册后，再来进行查询操作",
                }).then(() => {
                    this.$router.push({ path: '/buy/login' });
                }).catch(() => { });
                return;
            }
        },

        goIntroduction() {
            window.location.href = 'https://beian.miit.gov.cn/'
        },

        toOut() {
            var loginPhone = localStorage.getItem('myLoginPhone');
            if (loginPhone && loginPhone.length > 5) {
                Dialog.confirm({
                    title: "温馨提示",
                    message: "确定要进行注销手机号操作吗？ ",
                }).then(() => {
                    localStorage.removeItem('myLoginPhone')
                    localStorage.removeItem('myNikeName')
                    Toast.fail('注销成功！');
                    this.loginText = "登录/注册";
                    location.reload();
                }).catch(() => { });
            } else {
                Toast.fail('未查询到注册信息！');
            }
        },


        onChange(data) {
            console.log(data)
            if (data === 0) {
                this.$router.push({ path: '/buy/home' });
            } else if (data === 1) {
                this.toKefuUrl();
            }
        },
        login() {
            this.$router.push({ path: '/buy/login' });
        },
        toKefuUrl() {
            wxRequest("sim/kefu/url", { iccid: this.iccid }, "post").then(res => {
                if (res.data.code == '200') {
                    window.location.href = res.data.data;
                } else {
                    Dialog.alert({
                        title: '提示',
                        message: res.data.message
                    });
                }
            })
        },
    }
}
</script>
<style lang="less" scoped>
// 颜色变量定义
@page-bg: #f8f9fa;
@card-bg: #ffffff;
@userinfo-bg: linear-gradient(135deg, #f0f7ff 0%, #e6f0ff 100%);
@order-bg: #f0f7ff;
@order-item-bg: #ffffff;
@we-bg: #f0f7ff;
@text-primary: #111517;
@text-secondary: #6f7378;
@text-tertiary: #a2a7ad;
@accent-color: #437de0;

.page {
    background: @page-bg;
    padding-bottom: 20px;
    min-height: 100vh;
}

.userInfo {
    background: @userinfo-bg;
    padding: 36px 18px 18px 18px;
    position: relative;
    border-radius: 0 0 20px 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

    .bjimg {
        position: absolute;
        width: 380px;
        right: 0;
        top: 0;
        opacity: .7;
        z-index: 1;
    }

    .logo {
        border-radius: 36px;
        width: 73px;
        height: 73px;
        overflow: hidden;
        position: relative;
        margin-bottom: 18px;
        z-index: 3;
        box-shadow: 0 4px 15px rgba(67, 125, 224, 0.2);

        img {
            width: 73px;
            height: 73px;
        }
    }

    .title {
        font-size: 20px;
        font-family: Medium, sans-serif;
        margin-bottom: 18px;
        display: flex;
        color: @text-primary;
        align-items: center;
    }

    .user-item {
        display: flex;
        font-size: 18px;
        margin-bottom: 9px;
        z-index: 999;
        position: relative;

        .label {
            color: @text-tertiary;
        }

        .value {}
    }
}

.order-container {
    background: @page-bg;
    padding: 20px 18px;
}

.order {
    height: 302px;
    background-color: @order-bg;
    border-radius: 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

    .main {
        padding: 27px;

        .top {
            display: flex;
            align-items: center;
            position: relative;

            img {
                width: 36px;
            }

            .order-top-title {
                font-size: 20px;
                font-family: Medium, sans-serif;
                margin-left: 13px;
                color: @text-primary;
            }

            .order-top-allOrder {
                position: absolute;
                right: 0px;
                color: @text-tertiary;
                font-size: 16px;
                display: flex;
                align-items: center;
            }
        }

        .orders {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            text-align: center;

            .order-item {
                width: 47%;
                background: @order-item-bg;
                border-radius: 12px;
                margin-top: 18px;
                padding: 17px 0;
                position: relative;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
                transition: transform 0.2s ease;
                display: flex;
                align-items: center;
                justify-content: center;
                .order-1{
                    margin-left:10px;
                }
                &:hover {
                    transform: translateY(-2px);
                }

                .order-item-text {
                    color: @text-tertiary;
                    font-size: 16px;
                    margin-top: 4px;
                    margin-top: 2px; // 调整与数字的距离
                }

                .order-count {
                    font-size: 20px;
                    font-weight: bold;
                    color: #ff4d4f; // 红色更醒目
                    margin: 4px 0; // 增加上下间距
                    position: relative;
                    display: inline-block;
                    padding: 0 6px;
                    border-radius: 12px;
                    background-color: rgba(255, 77, 79, 0.1); // 浅色背景徽章效果
                }

                .order-count3 {
                    font-size: 20px;
                    font-weight: bold;
                    color: #52C41A; // 红色更醒目
                    margin: 4px 0; // 增加上下间距
                    position: relative;
                    display: inline-block;
                    padding: 0 6px;
                    border-radius: 12px;
                    background-color: rgba(255, 77, 79, 0.1); // 浅色背景徽章效果
                }
                .order-count1 {
                    font-size: 20px;
                    font-weight: bold;
                    color: #F5A623; // 红色更醒目
                    margin: 4px 0; // 增加上下间距
                    position: relative;
                    display: inline-block;
                    padding: 0 6px;
                    border-radius: 12px;
                    background-color: rgba(255, 77, 79, 0.1); // 浅色背景徽章效果
                }
                .order-count2 {
                    font-size: 20px;
                    font-weight: bold;
                    color: #1890FF; // 红色更醒目
                    margin: 4px 0; // 增加上下间距
                    position: relative;
                    display: inline-block;
                    padding: 0 6px;
                    border-radius: 12px;
                    background-color: rgba(255, 77, 79, 0.1); // 浅色背景徽章效果
                }
            }
        }
    }
}

.we {
    padding: 0 18px 36px 18px;
    background: @page-bg;

    .userfeedback {
        font-size: 18px;
        font-family: Medium, sans-serif;
        height: 91px;
        line-height: 72px;
        text-align: center;
        padding: 9px 0;
        background-image: url('~@/assets/wen/yjfk.png');
        background-size: 100%;
        background-position: 50%;
        background-repeat: no-repeat;
        background-color: @card-bg;
        border-radius: 12px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    }
}

.title-name {
    text-align: center;
    font-size: 20px;
    margin-top: 30px;
}

.kefu-img {
    width: 260px;
    height: 340px;
    margin: 20px auto;

    img {
        width: 100%;
        height: 100%;
        border-radius: 5px;
    }
}

.f-tab {
    background-color: @card-bg;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}
</style>